import React from 'react';

export default () => (
    <div>
            {/*<h1>404: Page not found</h1>*/}
    </div>
);
